function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5471 6.26219C15.9134 5.89591 16.5272 5.91583 16.918 6.30669C17.3089 6.69755 17.3288 7.31134 16.9625 7.67762L13.0278 11.6123L16.9626 15.5471C17.3289 15.9134 17.309 16.5272 16.9181 16.918C16.5273 17.3089 15.9135 17.3288 15.5472 16.9625L11.6124 13.0277L7.67762 16.9625C7.31134 17.3288 6.69755 17.3089 6.30669 16.918C5.91583 16.5272 5.89591 15.9134 6.26219 15.5471L10.197 11.6123L6.26229 7.67762C5.89601 7.31134 5.91594 6.69755 6.30679 6.30669C6.69765 5.91583 7.31144 5.89591 7.67772 6.26219L11.6124 10.1969L15.5471 6.26219Z"
});

var SvgIcoCross = function SvgIcoCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: 797979,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-cross.908146fe.svg";
export { ForwardRef as ReactComponent };